// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__RL1ja"};